<ng-content />
<button type="button" class="password-toggle__button" tabindex="-1" [attr.aria-label]="label" [title]="label" (click)="toggle()">
    <fa-icon [icon]="visible ? faEyeSlash : faEye" />
</button>
